import React, { useEffect, useRef, useState } from 'react';
import v1 from './assets/videos/CadburyDairyMilkwithoutwatermark.mp4';
import v2 from './assets/videos/ChatGPT.mp4';
import v3 from './assets/videos/LintLindor.mp4';
import v4 from './assets/videos/Pandora.mp4';
import v5 from './assets/videos/Primark.mp4';
import v6 from './assets/videos/Rang Rasiya Red maroon.mp4';
import v7 from './assets/videos/RangRasiyaBlue.mp4';
import v8 from './assets/videos/StellaArtios.mp4';
import v9 from './assets/videos/Tiffany&co.mp4';
import v10 from './assets/videos/YankeeCandleHotHotChocolate.mp4';
import v11 from './assets/videos/yankeecandleLavenderwithoutwatermark.mp4';

const videos = [
  { id: 1, videoUrl: v6, name: 'Rang Rasiya Red' },
  { id: 2, videoUrl: v9, name: 'Tiffany & Co' },
  { id: 3, videoUrl: v5, name: 'Primark' },
  { id: 4, videoUrl: v4, name: 'Pandora' },
  { id: 5, videoUrl: v11, name: 'Yankee Candle Lavender' },
  { id: 6, videoUrl: v7, name: 'Rang Rasiya Blue' },
  { id: 7, videoUrl: v1, name: 'Cadbury Dairy Milk' },
  { id: 8, videoUrl: v2, name: 'ChatGPT' },
  { id: 9, videoUrl: v3, name: 'Lindt Lindor' },
  { id: 10, videoUrl: v8, name: 'Stella Artios' },
  { id: 11, videoUrl: v10, name: 'Yankee Candle Hot Chocolate' },
];

const LAPTOP_BREAKPOINT = 1024;

const VideoAds = () => {
  const rowRef = useRef(null);
  const containerRef = useRef(null);
  const translateXRef = useRef(0);
  const [translateX, setTranslateX] = useState(0);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const isDraggingRef = useRef(false);
  const startXRef = useRef(0);
  const startTranslateRef = useRef(0);
  const didDragRef = useRef(false);
  const minTranslateXRef = useRef(0);
  const videoRefs = useRef([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isLaptop, setIsLaptop] = useState(false);

  const getClientX = (e) => (e.touches ? e.touches[0].clientX : e.clientX);

  const updateBounds = () => {
    const row = rowRef.current;
    const container = containerRef.current;
    if (!row || !container) return;
    const rowWidth = row.offsetWidth;
    const containerWidth = container.offsetWidth;
    const min = rowWidth <= containerWidth ? 0 : -(rowWidth - containerWidth);
    minTranslateXRef.current = min;
    const current = translateXRef.current;
    if (current > 0) {
      translateXRef.current = 0;
      setTranslateX(0);
    } else if (current < min) {
      translateXRef.current = min;
      setTranslateX(min);
    }
  };

  const handlePointerDown = (e) => {
    isDraggingRef.current = true;
    setIsDragging(true);
    didDragRef.current = false;
    startXRef.current = getClientX(e);
    startTranslateRef.current = translateXRef.current;
  };

  const handlePointerMove = (e) => {
    if (!isDraggingRef.current) return;
    if (e.cancelable && e.type === 'touchmove') e.preventDefault();
    const x = getClientX(e);
    const delta = x - startXRef.current;
    if (Math.abs(delta) > 5) didDragRef.current = true;
    const min = minTranslateXRef.current;
    const next = Math.max(min, Math.min(0, startTranslateRef.current + delta));
    translateXRef.current = next;
    setTranslateX(next);
    if (rowRef.current) {
      rowRef.current.style.transform = `translateX(${next}px)`;
    }
  };

  const handlePointerUp = () => {
    isDraggingRef.current = false;
    setIsDragging(false);
  };

  const handlePointerLeave = () => {
    isDraggingRef.current = false;
    setIsDragging(false);
  };

  const handleCardClick = (video) => {
    if (!didDragRef.current) setSelectedVideo(video);
  };

  const SLIDE_STEP = 320;
  // Left arrow: list slides left-to-right (row moves right, translateX increases). Cap at 0 (first video).
  const slideLeft = () => {
    const next = Math.min(0, translateXRef.current + SLIDE_STEP);
    translateXRef.current = next;
    setTranslateX(next);
  };
  // Right arrow: list slides right-to-left (row moves left, translateX decreases). Cap at min (last video).
  const slideRight = () => {
    const next = Math.max(minTranslateXRef.current, translateXRef.current - SLIDE_STEP);
    translateXRef.current = next;
    setTranslateX(next);
  };

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const onTouchMove = (e) => {
      if (isDraggingRef.current && e.cancelable) e.preventDefault();
    };
    el.addEventListener('touchmove', onTouchMove, { passive: false });
    return () => el.removeEventListener('touchmove', onTouchMove);
  }, []);

  useEffect(() => {
    updateBounds();
    const row = rowRef.current;
    const container = containerRef.current;
    if (!row || !container) return;
    const ro = new ResizeObserver(updateBounds);
    ro.observe(row);
    ro.observe(container);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${LAPTOP_BREAKPOINT}px)`);
    const handle = () => setIsLaptop(mq.matches);
    handle();
    mq.addEventListener('change', handle);
    return () => mq.removeEventListener('change', handle);
  }, []);

  useEffect(() => {
    if (!isLaptop) return;
    videoRefs.current.forEach((el, i) => {
      if (!el) return;
      if (i === hoveredIndex) {
        el.play().catch(() => {});
      } else {
        el.pause();
        el.currentTime = 0;
      }
    });
  }, [hoveredIndex, isLaptop]);

  return (
    <section className="bg-accent-light/50 py-12 md:py-16 lg:py-24 overflow-x-hidden w-full max-w-[100vw]">
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8">
        <div className="mb-8 md:mb-12">
          <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold mb-4 leading-[1.1] tracking-tight">
            <span className="block text-ink">Video Ads</span>
            <span className="block text-brand">That Work.</span>
          </h2>
          <div className="mt-6">
            <img
              src="https://cdn.prod.website-files.com/684079d0076841fffa4b64ad/684741c549644635f624f4f2_Commercials-Lines.svg"
              alt="Decorative Lines"
              className="w-full max-w-2xl h-auto opacity-80"
            />
          </div>
        </div>
      </div>

      {/* Single full-width row - grab and drag or use arrows */}
      <div
        className="relative w-full"
        style={{ width: '100vw', maxWidth: '100vw', marginLeft: 'calc(-50vw + 50%)' }}
      >
        <button
          type="button"
          onClick={slideLeft}
          className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/90 hover:bg-white shadow-lg border border-brand/20 flex items-center justify-center text-brand hover:scale-105 active:scale-95 transition-all"
          aria-label="Slide left"
        >
          <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          type="button"
          onClick={slideRight}
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/90 hover:bg-white shadow-lg border border-brand/20 flex items-center justify-center text-brand hover:scale-105 active:scale-95 transition-all"
          aria-label="Slide right"
        >
          <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
        <div
          ref={containerRef}
          className="w-full overflow-hidden select-none py-12 lg:py-16"
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerUp={handlePointerUp}
          onPointerLeave={handlePointerLeave}
          onPointerCancel={handlePointerUp}
          onTouchStart={handlePointerDown}
          onTouchMove={handlePointerMove}
          onTouchEnd={handlePointerUp}
          onTouchCancel={handlePointerUp}
        >
          <div
            ref={rowRef}
            className="flex gap-2 sm:gap-4 md:gap-5 lg:gap-6 w-max px-3 sm:px-6 lg:px-8 items-center"
            style={{
              transform: `translateX(${translateX}px)`,
              transition: isDragging ? 'none' : 'transform 0.3s ease-out',
            }}
          >
            {videos.map((video, index) => {
              const isHovered = isLaptop && hoveredIndex === index;
              return (
                <div
                  key={`${video.id}-${index}`}
                  className={`flex-shrink-0 w-44 sm:w-56 md:w-64 lg:w-80 xl:w-96 relative group cursor-grab active:cursor-grabbing transition-transform duration-300 ease-out origin-center ${
                    isHovered ? 'scale-110 -translate-y-6 z-20' : ''
                  }`}
                  onClick={() => handleCardClick(video)}
                  onMouseEnter={() => isLaptop && setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <div
                    className={`relative overflow-hidden rounded-lg shadow-lg border-2 border-brand/60 transition-all duration-300 ease-out ${
                      isHovered ? 'border-brand shadow-2xl' : 'group-hover:border-brand'
                    }`}
                  >
                    <video
                      ref={(el) => { videoRefs.current[index] = el; }}
                      src={video.videoUrl}
                      className="w-full h-32 sm:h-40 md:h-48 lg:h-56 xl:h-64 object-cover"
                      muted
                      loop
                      playsInline
                    />
                    <div
                      className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
                        isHovered ? 'bg-black/0' : 'bg-black/20 group-hover:bg-black/10'
                      }`}
                    >
                      <div
                        className={`w-10 h-10 sm:w-14 sm:h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 bg-white rounded-full flex items-center justify-center shadow-md transition-all duration-300 ${
                          isHovered ? 'scale-75 opacity-0' : 'group-hover:scale-110'
                        }`}
                      >
                        <svg
                          className="w-5 h-5 sm:w-7 sm:h-7 md:w-8 md:h-8 lg:w-10 lg:h-10 text-brand ml-0.5 sm:ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {selectedVideo && (() => {
        const currentIndex = videos.findIndex((v) => v.videoUrl === selectedVideo.videoUrl && v.id === selectedVideo.id);
        const hasPrevious = currentIndex > 0;
        const hasNext = currentIndex >= 0 && currentIndex < videos.length - 1;
        return (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4"
            onClick={() => setSelectedVideo(null)}
          >
            <div
              className="relative w-full max-w-5xl flex items-center gap-2 sm:gap-4"
              onClick={(e) => e.stopPropagation()}
            >
              {hasPrevious && (
                <button
                  type="button"
                  onClick={() => setSelectedVideo(videos[currentIndex - 1])}
                  className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/90 hover:bg-white shadow-lg border border-white/30 flex items-center justify-center text-black hover:scale-105 active:scale-95 transition-all"
                  aria-label="Previous video"
                >
                  <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
              )}
              <div className="relative flex-1 min-w-0 bg-black rounded-lg overflow-hidden">
                <button
                  onClick={() => setSelectedVideo(null)}
                  className="absolute top-4 right-4 z-10 w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full flex items-center justify-center transition-all"
                  aria-label="Close video"
                >
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                  <video
                    key={selectedVideo.videoUrl}
                    className="absolute top-0 left-0 w-full h-full"
                    controls
                    autoPlay
                    src={selectedVideo.videoUrl}
                  >
                    <source src={selectedVideo.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              {hasNext && (
                <button
                  type="button"
                  onClick={() => setSelectedVideo(videos[currentIndex + 1])}
                  className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/90 hover:bg-white shadow-lg border border-white/30 flex items-center justify-center text-black hover:scale-105 active:scale-95 transition-all"
                  aria-label="Next video"
                >
                  <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        );
      })()}
    </section>
  );
};

export default VideoAds;
